import AccessRightAccordion from "./accessRightAccordion.container";

export default AccessRightAccordion;
